import { db } from '../../common/config/Firebase';

/**
 * Fetches employee data by DNI
 * @param {string} dni - Employee DNI
 * @returns {Promise<Object|null>} - Employee data or null if not found
 */
export const getEmployeeByDniUseCase = async (dni) => {
    try {
        const docRef = db.collection('employees').doc(dni);
        const doc = await docRef.get();

        if (!doc.exists) {
            console.log('Employee not found:', dni);
            return null;
        }

        return {
            dni: doc.id,
            ...doc.data()
        };
    } catch (error) {
        console.error('Error fetching employee:', error);
        throw error;
    }
};
